import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { users } from '../services/api';
import LayoutV2 from '../components/LayoutV2';

export default function ChangePasswordV2() {
  const navigate = useNavigate();
  
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await users.changePassword(currentPassword, newPassword);
      setSuccess('Password changed successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <LayoutV2>
      <div className="space-y-4">
        <div>
          <h1 className="text-lg font-semibold text-white">Change Password</h1>
          <p className="text-sm text-slate-400">Update your password to keep your account secure.</p>
        </div>

        <div className="rounded-xl border border-slate-700 bg-[#1e293b] p-4 sm:p-5">
          {error && (
            <div className="mb-3 rounded-lg border border-red-500/30 bg-red-950/30 p-2 text-xs text-red-200">
              {error}
            </div>
          )}

          {success && (
            <div className="mb-3 rounded-lg border border-emerald-500/30 bg-emerald-950/30 p-2 text-xs text-emerald-200">
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="mb-1 block text-xs text-slate-400">Current Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="h-11 min-h-[44px] w-full rounded-xl border border-slate-700 bg-slate-900 px-3 text-sm text-white focus:outline-none focus:ring-2 focus:ring-teal-400"
                required
              />
            </div>

            <div>
              <label className="mb-1 block text-xs text-slate-400">New Password (min 6 characters)</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="h-11 min-h-[44px] w-full rounded-xl border border-slate-700 bg-slate-900 px-3 text-sm text-white focus:outline-none focus:ring-2 focus:ring-teal-400"
                required
              />
            </div>

            <div>
              <label className="mb-1 block text-xs text-slate-400">Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="h-11 min-h-[44px] w-full rounded-xl border border-slate-700 bg-slate-900 px-3 text-sm text-white focus:outline-none focus:ring-2 focus:ring-teal-400"
                required
              />
            </div>

            <div className="pt-1">
              <button
                type="submit"
                disabled={loading}
                className="h-11 min-h-[44px] w-full rounded-xl bg-teal-400 text-sm font-semibold text-slate-950 transition-colors hover:bg-teal-300 disabled:opacity-60"
              >
                {loading ? 'Changing...' : 'Change Password'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </LayoutV2>
  );
}
